import { render, staticRenderFns } from "./Virtuals.vue?vue&type=template&id=b1920c22&"
import script from "./Virtuals.vue?vue&type=script&lang=js&"
export * from "./Virtuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports